<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Pending Amount
        </h4>

        <div class="form-group mt-3 mb-0">
          <label for="statusFilter">Filter by Payment Status:</label>
          <select
            id="statusFilter"
            class="form-control w-auto d-inline-block ml-2"
            [(ngModel)]="selectedStatus"
            (change)="changeStatus()"
          >
            <option value="">All</option>
            <option value="true">Paid</option>
            <option value="false">Pending</option>
          </select>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">User Name</th>
              <th scope="col">Type of rental</th>
              <th scope="col">Extra Time</th>
              <th scope="col">OutStanding Amount</th>
              <th scope="col">Payment Status</th>
              <th scope="col">Phone Number</th>
              <th scope="col">Created At</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of pendingPayments">
              <td>{{ d.user_id.username ? d.user_id.username : "-" }}</td>
              <td>{{ d.type ? d.type : "-" }}</td>
              <td>
                {{ d?.totalTime ? d.totalTime : "-" }}
              </td>
              <td>{{ d.amount ? d.amount.toFixed(2) : "-" }}</td>
              <td>
                <span
                  class="badge rounded-pill px-3"
                  [ngClass]="{
                    'badge-success': d.paymentStatus === 'paid',
                    'badge-danger': d.paymentStatus === 'pending',
                    'badge-info': d.paymentStatus === 'waived'
                  }"
                  style="font-size: 100%"
                >
                  {{ d.paymentStatus | titlecase }}
                </span>
              </td>
              <td>{{ d?.user_id?.mobile ? d?.user_id?.mobile : "-" }}</td>
              <td>{{ d?.created_at | date : "medium" }}</td>

              <td>
                <a
                  href="javascript:void(0);"
                  class="link mr-2"
                  (click)="requestPayment(d, 'waived')"
                  ngbTooltip="Update Payment"
                  *ngIf="d.paymentStatus == 'pending'"
                >
                  <i class="fa fa-paper-plane"></i>
                </a>
                <a
                  href="javascript:void(0);"
                  class="link mr-2"
                  (click)="requestPayment(d, 'reminder')"
                  ngbTooltip="Reminder"
                  *ngIf="d.paymentStatus == 'pending'"
                >
                  <i class="fa fa-bell"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="pendingPayments.length === 0">
              <td colspan="7" class="text-center">No data found</td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="pendingPayments.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="mb-3 d-flex">
      <div class="font-weight-bold" style="width: 150px">User Name:</div>
      <div>{{ detail.user_id.username ? detail.user_id.username : "-" }}</div>
    </div>

    <div class="mb-3 d-flex">
      <div class="font-weight-bold" style="width: 150px">Rental Type:</div>
      <div>{{ detail.type ? detail.type : "-" }}</div>
    </div>

    <div class="mb-3 d-flex">
      <div class="font-weight-bold" style="width: 150px">Extra Time:</div>
      <div>
        {{ detail.payload?.extraTime ? detail.payload.extraTime : "-" }}
      </div>
    </div>

    <div class="mb-3 d-flex">
      <div class="font-weight-bold" style="width: 150px">Amount:</div>
      <div>{{ detail.amount ? detail.amount.toFixed(2) : "-" }}</div>
    </div>

    <div class="mb-3 d-flex">
      <div class="font-weight-bold" style="width: 150px">Commission:</div>
      <div>
        {{
          detail.payload?.commissionPercent > 0
            ? detail.payload.commissionPercent + "%"
            : "-"
        }}
      </div>
    </div>

    <div
      class="d-flex mt-4 align-items-center"
      *ngIf="detail.actionType == 'waived'"
    >
      <div class="font-weight-bold mb-2">Payment Status:</div>
      <div class="ml-2 d-flex align-items-center">
        <ui-switch
          [checked]="detail.status"
          (change)="togglePaymentStatus()"
        ></ui-switch>
        <label class="ml-2"> </label>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Close
    </button>

    <button
      type="button"
      class="btn btn-primary"
      (click)="savePaymentStatus()"
      [disabled]="detail.actionType === 'waived' && !detail.status"
    >
      {{ detail.actionType === "waived" ? "Save" : "Send Reminder" }}
    </button>
  </div>
</ng-template>
